import { defineStore } from 'pinia'
import api from '@/api/axios'

export const useExportsStore = defineStore('exports', {
    state: () => ({
        exports: {
            items: [],
            count: 0
        },
        currentExport: null,
        pageSize: 20,
    }),
    getters: {
        allExports: (state) =>
            state.exports.items.map((category) => ({
                ...category,
                id: category._id?.$oid || category._id,
            })),
        countPages: (state) => Math.ceil(state.exports.count / state.pageSize) || 1,
    },

    actions: {
        async getExports(page = 1) {
            try {
                const response = await api.get('/exports?limit='+this.pageSize+'&page='+page);
                this.exports = response.data;
            } catch (error) {
                console.error('Failed to fetch providers:', error);
                throw error;
            }
        },

        // async getProvider(id) {
        //     try {
        //         const response = await api.get(`/products/${id}`);
        //         this.currentProduct = response.data;
        //     } catch (error) {
        //         console.error('Failed to fetch provider:', error);
        //         throw error;
        //     }
        // },
        //
        // async addProvider(providerData) {
        //     try {
        //         const response = await api.post('/products', providerData);
        //         this.products.push(response.data); // Додаємо в локальний список
        //     } catch (error) {
        //         console.error('Failed to add provider:', error);
        //         throw error;
        //     }
        // },
        //
        // async updateProvider(id, providerData) {
        //     try {
        //         const response = await api.put(`/providers/${id}`, providerData);
        //         const index = this.providers.findIndex((p) => p.id === id);
        //         if (index !== -1) {
        //             this.providers[index] = response.data;
        //         }
        //     } catch (error) {
        //         console.error('Failed to update provider:', error);
        //         throw error;
        //     }
        // },
        //
        // async deleteProvider(id) {
        //     try {
        //         await api.delete(`/providers/${id}`);
        //         this.providers = this.providers.filter((p) => p.id !== id);
        //     } catch (error) {
        //         console.error('Failed to delete provider:', error);
        //         throw error;
        //     }
        // },
    },
});